import { jsx as _jsx } from "react/jsx-runtime";
import { toClassName } from '../../utils/ClassNameUtils.js';
import { toTextStyleClassName } from '../../utils/TextStylePropsUtils.js';
export function TextArea({ className, fixedSize, readOnly, style, textStyle, defaultValue, value, onChange, }) {
    return (_jsx("textarea", { className: toClassName('textarea', fixedSize && 'has-fixed-size', textStyle && toTextStyleClassName(textStyle), className), readOnly: readOnly, style: style, defaultValue: defaultValue, value: value, onChange: onChange }));
}
//# sourceMappingURL=TextArea.js.map